module.exports = __webpack_public_path__ + "img/bgc16.f9b29b07.png";